import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import cx from 'classnames';

// Components
import TextualAction from '../../../atoms/textualAction';
import Button from '../../../../../atoms/Button';

// Constants
import { ADD_NEW_FILTER, RESET_FILTER, APPLY_FILTERS } from './constants/filterFooter.actionTypes';

// Styles
import s from './filterFooter.module.scss';
var FilterFooter = /*#__PURE__*/function (_PureComponent) {
  _inherits(FilterFooter, _PureComponent);
  var _super = _createSuper(FilterFooter);
  function FilterFooter() {
    var _this;
    _classCallCheck(this, FilterFooter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleAddFilter", function () {
      var onAction = _this.props.onAction;
      onAction({
        type: ADD_NEW_FILTER
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleResetFilters", function () {
      var onAction = _this.props.onAction;
      onAction({
        type: RESET_FILTER
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleFilterApply", function () {
      var onAction = _this.props.onAction;
      onAction({
        type: APPLY_FILTERS
      });
    });
    return _this;
  }
  _createClass(FilterFooter, [{
    key: "renderLeftSection",
    value: function renderLeftSection() {
      return /*#__PURE__*/React.createElement(TextualAction, {
        label: __('Add Filter'),
        onClick: this.handleAddFilter
      });
    }
  }, {
    key: "renderRightSection",
    value: function renderRightSection() {
      var _this$props = this.props,
        isModified = _this$props.isModified,
        showReset = _this$props.showReset;
      return /*#__PURE__*/React.createElement("div", {
        className: s.rightSection
      }, showReset && /*#__PURE__*/React.createElement(TextualAction, {
        label: __('Reset'),
        className: s.resetAction,
        onClick: this.handleResetFilters,
        isDisabled: !isModified
      }), /*#__PURE__*/React.createElement(Button, {
        view: "primary",
        type: "button",
        onClick: this.handleFilterApply
      }, __('Apply')));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        showAddFilter = _this$props2.showAddFilter,
        isReadOnly = _this$props2.isReadOnly;
      if (isReadOnly) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(_defineProperty({}, s.withoutAddFilter, !showAddFilter), s.container)
      }, showAddFilter && this.renderLeftSection(), this.renderRightSection());
    }
  }]);
  return FilterFooter;
}(PureComponent);
FilterFooter.propTypes = {
  onAction: PropTypes.func,
  isModified: PropTypes.bool,
  showAddFilter: PropTypes.bool,
  showReset: PropTypes.bool,
  isReadOnly: PropTypes.bool
};
FilterFooter.defaultProps = {
  onAction: _noop,
  isModified: true,
  showAddFilter: true,
  showReset: true,
  isReadOnly: false
};
export default FilterFooter;